import { render, staticRenderFns } from "./add-blog-dialog.vue?vue&type=template&id=c47024ac&"
import script from "./add-blog-dialog.vue?vue&type=script&lang=js&"
export * from "./add-blog-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports